import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_banner_pitch = _resolveComponent("banner-pitch")!
  const _component_highlight_overlay = _resolveComponent("highlight-overlay")!
  const _component_two_column_pitch = _resolveComponent("two-column-pitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_banner_pitch, {
      image: $data.pitches.banner.imageSrc,
      pageDescription: ""
    }, {
      bannerHTMLLarge: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "" }, "Improve Outcomes", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "" }, "Reduce Costs", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "pitch-font" }, "IntelligentRx's clinically active pharmacy program", -1)),
        _createVNode(_component_router_link, {
          to: "/request-a-demo",
          class: "btn btn-lg",
          style: {"background":"var(--background-color-attention-emphasis) 0% 0% no-repeat padding-box","color":"black"}
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createTextVNode(" Learn More ", -1)),
            _createVNode(_component_font_awesome_icon, {
              icon: "fa fa-arrow-right",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        })
      ]),
      bannerHTMLMobile: _withCtx(() => [
        _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "" }, "Improve Outcomes", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "" }, "Reduce Costs", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "pitch-font" }, "IntelligentRx's clinically active pharmacy program", -1)),
        _createVNode(_component_router_link, {
          to: "/request-a-demo",
          class: "btn btn-lg my-4",
          style: {"background":"var(--background-color-attention-emphasis) 0% 0% no-repeat padding-box","color":"black"}
        }, {
          default: _withCtx(() => [
            _cache[5] || (_cache[5] = _createTextVNode("Request a Demo ", -1)),
            _createVNode(_component_font_awesome_icon, {
              icon: "fa fa-arrow-right",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["image"]),
    _createVNode(_component_highlight_overlay, {
      title: $data.pitches.highlightOverlayThomas.title,
      text: $data.pitches.highlightOverlayThomas.text,
      imageSrc: $data.pitches.highlightOverlayThomas.imageSrc
    }, null, 8, ["title", "text", "imageSrc"]),
    _createVNode(_component_two_column_pitch, {
      title: "Good for Patients",
      pitches: $data.pitches.outcomesAndCosts,
      overallClass: 'pitch-background-default'
    }, null, 8, ["pitches"]),
    _createVNode(_component_two_column_pitch, {
      title: "Good for Doctors",
      pitches: $data.pitches.activeAndClinical,
      overallClass: 'pitch-background-default'
    }, null, 8, ["pitches"]),
    _createVNode(_component_two_column_pitch, {
      title: "Easy to Start",
      pitches: $data.pitches.cooperativeAndPharmacists,
      overallClass: 'pitch-background-default'
    }, null, 8, ["pitches"]),
    _createVNode(_component_two_column_pitch, {
      title: "Good for Patients",
      pitches: $data.pitches.outcomesOverMoney,
      overallClass: 'pitch-background-default'
    }, null, 8, ["pitches"])
  ]))
}